import { animate, state, style, transition, trigger, keyframes } from '@angular/animations';

export const FLIP_X_ANIMATION =
	trigger('flipXTrigger', [
		state('on', style({
            	transform: 'rotateX(179.9deg)'
		})),
		state('off',   style({
            	transform: 'rotateX(0)'
		})),
	transition('on => off', animate('1s ease-out')),
      transition('off => on', animate('1s ease-in', keyframes(
		[
			//style({transform: 'translateZ(-500px)', offset: 0.25}),
			//style({transform: 'translateZ(-500px) rotateX(179.9deg)',  offset: 0.75}),
			style({transform: 'rotateX(179.9deg)',  offset: 1.0})
		    ]
	)))
    ]); 
    
export const FLIP_Y_ANIMATION =
	trigger('flipYTrigger', [
		state('on', style({
            	transform: 'rotateY(180deg)'
		})),
		state('off',   style({
            	transform: 'rotateY(0)'
		})),
		transition('on => off', animate('750ms')),
		transition('off => on', animate('750ms'))
	]); 